import { ThemeOptions } from '@mui/material';

import { tokens } from '../../theme/generated/tokens';

export const linkTheme: ThemeOptions['components'] = {
  MuiLink: {
    styleOverrides: {
      root: {
        color: tokens.theme.fg.action.primary,
      },
    },
  },
};
